
import { mixins, Options } from 'vue-class-component'
import BaseFormMixin from '@/components/common/mixins/BaseFormMixin.vue'
import { maska } from 'maska'
import { IDateRangePicker, IOverViewPopupRequest } from '@/utils/types'
import { ChartModel } from '@/models/chart-model'
import { ACTION_CAMPAIGN, ACTION_POPUP } from '@/store/actions'
import { Formater } from '@/utils/formater'
import { Watch } from 'vue-property-decorator'
import { DatetimeUtils } from '@/utils/datetime'
import EChart from '@/components/app/EChart.vue'
import CLoading from '@/components/common/ui/CLoading.vue'
import DateRangeSelectorV2 from '@/components/common/ui/DateRangeSelectorV2.vue'

@Options({
  components: { DateRangeSelectorV2, CLoading, EChart },
  directives: { maska },
})
export default class ChartOfPopupDetails extends mixins(BaseFormMixin) {
  loading = true
  firstLoad = true
  componentKey = 1
  chart_title = ''
  currentDateType = ''

  dateRange: IDateRangePicker = {
    startDate: '',
    endDate: '',
  }

  friendsChart: ChartModel = new ChartModel([], [])

  campaignsStatistic: IOverViewPopupRequest[] = []

  get selectedAppId() {
    return this.$route.params.app_id as string
  }

  get selectedCampaignId() {
    return this.$route.params.campaign_id as string || ''
  }

  get selectedPopupId() {
    return this.$route.params.popup_id || ''
  }

  async fetchSelectingApp() {
    this.campaignsStatistic = []
    if (!this.selectedCampaignId) {
      return
    }

    this.loading = true
    if (this.selectedPopupId) {
      const resp = await this.$store.dispatch(ACTION_POPUP.OVERVIEW_DETAIL, {
        app_id: this.selectedAppId,
        campaign_id: this.selectedCampaignId,
        popup_id: this.selectedPopupId,
        is_test_mode: false,
        date_from: DatetimeUtils.formatDate(this.dateRange.startDate),
        date_to: DatetimeUtils.formatDate(this.dateRange.endDate),
      })
      if (resp) {
        // eslint-disable-next-line
        this.campaignsStatistic = resp['popup']
      }
    } else {
      const resp = await this.$store.dispatch(ACTION_CAMPAIGN.OVERVIEW_DETAIL, {
        app_id: this.selectedAppId,
        campaign_id: this.selectedCampaignId,
        is_test_mode: false,
        date_from: DatetimeUtils.formatDate(this.dateRange.startDate),
        date_to: DatetimeUtils.formatDate(this.dateRange.endDate),
      })
      if (resp) {
        // eslint-disable-next-line
        this.campaignsStatistic = resp['campaign']
      }
    }
    this.initCharts()
    this.loading = false
  }

  initCharts(): void {
    this.friendsChart = new ChartModel([], [])
    const total = this.campaignsStatistic.length
    for (let index = total - 1; index >= 0; index--) {
      const item = this.campaignsStatistic[index]
      this.friendsChart.xAxis.push(item.date)
    }

    this.componentKey++
  }

  get seriesData() {
    const total_display: number[] = []
    const click_rate: number[] = []
    const total_click: number[] = []
    const total = this.campaignsStatistic.length
    for (let index = total - 1; index >= 0; index--) {
      const item = this.campaignsStatistic[index]
      total_display.push(item.total_display)
      click_rate.push(item.click_rate)
      total_click.push(item.total_click)
    }

    return [
      {
        name: this.$t('label.total_display'),
        type: 'line',
        data: total_display,
      },
      {
        name: this.$t('label.click_rate'),
        type: 'line',
        data: click_rate,
      },
      {
        name: this.$t('label.total_click'),
        type: 'line',
        data: total_click,
      },
    ]
  }

  numberWithCommas(num) {
    return Formater.numberFormat(num)
  }

  changeDateRange(value) {
    if (this.firstLoad) {
      return
    }
    this.dateRange = value
    this.fetchSelectingApp()
  }

  changeDate(type) {
    if (type === this.currentDateType) {
      this.currentDateType = ''
    } else {
      this.currentDateType = type
    }
  }

  @Watch('currentDateType')
  setDateRange() {
    this.dateRange = DatetimeUtils.getDateRange(this.currentDateType)
    this.fetchSelectingApp()
  }

  @Watch('selectedCampaignId', { immediate: true })
  selectedCampaignIdChanged() {
    this.dateRange = DatetimeUtils.getDateRange('last7Days')
    this.fetchSelectingApp()
    this.firstLoad = false
  }

  mounted() {
    this.chart_title = this.$t('label.initial.chart_title')
  }
}
